import { useContext, useState } from "react"
import { ItemsContext } from "../contexts/ItemsContext"
import { toast } from 'react-toastify'

const Login=()=>{

    const {loginUser,setLogin,setSignup}=useContext(ItemsContext)
    const [email,setEmail]=useState("")
     const [password,setPassword]=useState("")
     const [error, setError] = useState("");

const handleClick=()=>{
    setLogin(false)
    setSignup(false)
}
const handleClick2=()=>{
   setSignup(true)
   setLogin(false)
}

    const handleSubmit=(e)=>{
        e.preventDefault()
        loginUser(email,password)
        setEmail("")
        setPassword("")
        const success = loginUser(email, password);
        if (!success) {
          setError("Incorrect email or password");
        }
        if(success){
            toast.success('The user has successfully LOGGED IN', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                })
           // setTimeout(()=>alert("The user has successfully LOGGED IN."),100)  
        }
          
    }
                        // css convenient unification for one login/register className...
    return(
        <div className="register" id="login">
            <button className="back" onClick={handleClick}>Back</button>
            <h2>Log in</h2>
            {error && <div className="error">{error}</div>}
            <form onSubmit={handleSubmit}>
                <label>Email: </label>
                <input 
                    type="email" 
                    placeholder="Write a email..." 
                    value={email}
                    onChange={(e)=>setEmail(e.target.value)}
                    name="email"
                    autoComplete="email"
                    required
                /> 
                <label>Password: </label>
                <input 
                    type="password" 
                    placeholder="Write a password..." 
                    value={password}
                    onChange={(e)=>setPassword(e.target.value)}
                    name="password"
                    autoComplete="current-password"
                    required
                />
                <button id="loginButton">Log in</button>
            </form>  <br></br>
            <p>Don't have a TaskRanger account? <span className="back2" onClick={handleClick2}> {"  "}Sign up</span></p> 
        </div>
    )
}

export default Login